import { ExternalLink } from "../common";
import type { FaqSection } from "./types";

const supportedIntegrationTypes = [
  {
    title: "Finance Integrations",
    description:
      "Loan, lease, and PPA providers with features like instant credit decisions, soft credit pulls, and direct pay commissions.",
  },
  {
    title: "Design Integrations",
    description:
      "Tools like Aerialytic, Aurora, and OpenSolar for solar system modeling, battery sizing, and shade analysis.",
  },
  {
    title: "CRM, ERP, and Operations Tools",
    description: "Salesforce, HubSpot, and other workflow systems.",
  },
  {
    title: "Custom APIs and Webhooks",
    description: "REST API (v1), GraphQL API (v2), and webhook support for real-time data flow.",
  },
];

const integrationSupport = [
  {
    key: "technical-documentation",
    description: (
      <>
        Technical documentation (<ExternalLink href="https://docs.enerflo.io">docs.enerflo.io</ExternalLink>) for API
        and webhook support
      </>
    ),
  },
  {
    description: "Integration monitoring services to ensure reliability and uptime",
  },
  {
    description: "Dedicated account management and solution engineering for custom use cases",
  },
];

const integrationPartnersSection: FaqSection = {
  id: "enerflo-integrations",
  title: "Integration Partners",
  faqs: [
    {
      question: "Why should finance, design, or other technology companies partner with Enerflo?",
      answer: (
        <p>
          Enerflo is the solar industry’s operating system, connecting sales, financing, design, installation, and
          customer experience in one platform. By integrating with Enerflo, partners gain direct access to a growing
          network of installers, sales organizations, and hybrid solar companies, helping expand distribution, adoption,
          and usage of their products and services.
        </p>
      ),
    },
    {
      question: "What types of integrations does Enerflo support?",
      answer: (
        <>
          <p>Enerflo supports a wide variety of integrations, including:</p>
          <br />
          <ul className="list-disc space-y-1 ml-4">
            {supportedIntegrationTypes.map(item => (
              <li key={item.title}>
                <strong>{item.title}</strong> – {item.description}
              </li>
            ))}
          </ul>
          <br />
          <p>This flexibility makes it easier for partners to meet solar company needs at scale.</p>
        </>
      ),
    },
    {
      question: "How does Enerflo ensure integrations are successful?",
      answer: (
        <>
          <p>Enerflo provides:</p>
          <br />
          <ul className="list-disc space-y-1 ml-4">
            {integrationSupport.map(item => (
              <li key={"key" in item ? item.key : item.description}>{item.description}</li>
            ))}
          </ul>
          <br />
          <p>
            Partners benefit from co-marketing opportunities, increased visibility in the solar ecosystem, and a
            reputation for helping streamline the solar sales and install process.
          </p>
        </>
      ),
    },
  ],
};

export default integrationPartnersSection;
